import { DeleteOutlined, PaperClipOutlined } from '@ant-design/icons'
import { Flex, Image, Spin } from 'antd'
import { UploadFile } from 'antd/lib'
import cn from 'classnames'
import { useState } from 'react'

import { message, Text } from 'src/components'
import { getPreview } from 'src/features/questionnaires/utils'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'

type Media = {
  imageUrl: string
  mediaFile: UploadFile
}
type Props = {
  file: Media
  isPending?: boolean
  onRemove?: () => void
}

export const CustomItemRender = ({ file, isPending, onRemove }: Props) => {
  const [isLoading, setIsLoading] = useState(false)

  const [visible, setVisible] = useState(false)
  const [previewUrl, setPreviewUrl] = useState<string | undefined>(
    file?.imageUrl
  )

  const { t } = useLocales()
  const { styles } = useStyles()

  const onPreview = async () => {
    if (file?.mediaFile?.uid) {
      setIsLoading(true)
      try {
        const url = await getPreview(file?.mediaFile?.uid)
        setPreviewUrl(url)

        setVisible(true)
        setIsLoading(false)
      } catch {
        setIsLoading(false)
        message.error(t('errors.something_went_wrong'))
      }
    } else {
      setVisible(true)
    }
  }

  return (
    <Flex gap={8} align="center">
      {isPending || isLoading ? (
        <Spin />
      ) : (
        <>
          <Flex gap={8}>
            <PaperClipOutlined className={styles.fileIcon} />

            <Text className={styles.fileName} onClick={onPreview}>
              {file?.mediaFile?.fileName}
            </Text>
          </Flex>

          <Image
            preview={{
              visible,
              src: previewUrl,
              onVisibleChange: (value) => {
                setVisible(value)
              }
            }}
          />

          {onRemove && (
            <DeleteOutlined
              className={cn('pointer', styles.fileIcon)}
              size={16}
              onClick={onRemove}
            />
          )}
        </>
      )}
    </Flex>
  )
}
